export default [
   'context',
   'div',
   'id',
   'meta',
   'reference',
//   'resourceType',
   'system',
   'url'
]
